import { Tool } from '@backstage/plugin-home';
import {
  AdminGuidesIcon,
  ArgoIcon,
  GitLabIcon,
  OpenShiftIcon,
  UserGuidesIcon,
} from './icons';

export const tools: Tool[] = [
  {
    label: 'GitLab',
    url: 'https://gitlab.puzzle.ch',
    icon: <GitLabIcon />,
  },
  {
    label: 'Argo CD',
    url: 'https://argocd.puzzle.ch',
    icon: <ArgoIcon />,
  },
  {
    label: 'OpenShift',
    url: 'https://openshift.cloudscale.puzzle.ch',
    icon: <OpenShiftIcon color="primary" />,
  },
  {
    label: 'User Guides',
    url: 'https://docs.puzzle.ch/user-guides/',
    icon: <UserGuidesIcon />,
  },
  {
    label: 'Admin Guides',
    url: 'https://docs.puzzle.ch/admin-guides/',
    icon: <AdminGuidesIcon />,
  },
];
